// src/constants/medicalQuestions.js

export const MEDICAL_QUESTIONS = {
  'health-fg': [
    { key: 'Q1', text: 'Does member have any pre-existing disease?' },
    { key: 'Q2', text: 'Takes medicines regularly?' },
    { key: 'Q3', text: 'Has been advised investigation or further tests?' },
    { key: 'Q4', text: 'Was hospitalized in the past?' },
    {
      key: 'Q5',
      text: 'Does Person proposed to be insured smoke/consume alcohol?',
    },
    {
      key: 'Q6',
      text: 'Has the person ever filed a claim with previous insurer?',
    },
    {
      key: 'Q7',
      text: 'Has any proposal of life/health insurance been declined?',
    },
    { key: 'Q8', text: 'Has planned a surgery?' },
    { key: 'Q9', text: 'Is expecting a baby?' },
  ],
};
